/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Soft_Calm_Bat_RoarInputs */

const en_soft_calm_bat_roar = /** @type {(inputs: Soft_Calm_Bat_RoarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete User?`)
};

const de_soft_calm_bat_roar = /** @type {(inputs: Soft_Calm_Bat_RoarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzer entfernen?`)
};

/**
* | output |
* | --- |
* | "Delete User?" |
*
* @param {Soft_Calm_Bat_RoarInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const soft_calm_bat_roar = /** @type {((inputs?: Soft_Calm_Bat_RoarInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Soft_Calm_Bat_RoarInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_soft_calm_bat_roar(inputs)
	return de_soft_calm_bat_roar(inputs)
});